import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { UserService } from '../services/user.service';
import { PasswordValidator } from '../password.validator';
import { RegisterService } from '../services/register.service';
import { ActivatedRoute } from '@angular/router';
import { SocialUser, SocialAuthService, FacebookLoginProvider } from '@abacritt/angularx-social-login';
@Component({
	selector: 'app-invite-user',
	templateUrl: './invite-user.component.html',
	styleUrls: ['./invite-user.component.scss']
})
export class InviteUserComponent implements OnInit {
	user: SocialUser;
	loggedIn: boolean;
	inviteForm: UntypedFormGroup;
	facebook = false;

	constructor(
		private userService: UserService,
		private formBuilder: UntypedFormBuilder,
		private authService: SocialAuthService,
		private registerService: RegisterService,
		private route: ActivatedRoute,
	) { }

	ngOnInit(): void {
		this.userService.getUser().subscribe(u => this.user = u);
		this.inviteForm = this.formBuilder.group({
			name: ['', Validators.required],
			hp: ['', [Validators.pattern("01[0-9]{1}-?[0-9]*"), Validators.required]],
			password: ['', [Validators.required, Validators.minLength(6)]],
			password_confirmation: ['', Validators.required],
			subdomain: ['', Validators.required],
			token: ['', Validators.required],
		},{
			validator: PasswordValidator('password', 'password_confirmation')
		});
		this.route.queryParamMap.subscribe(params => {
			if (params.get('_subdomain')) {
				this.inviteForm.controls['subdomain'].setValue(params.get('_subdomain'));
			}
			if (params.get('company_name')) {
				
			}
			if (params.get('token')) {
				this.inviteForm.controls['token'].setValue(params.get('token'));
			}
			if (params.get('name')) {
				this.inviteForm.controls['name'].setValue(params.get('name'));
			}
		});
		this.authService.authState.subscribe((user) => {
			this.user = user;
			this.loggedIn = (user != null)
			if(this.user){
				// this.inviteForm.controls['provider'].setValue('facebook');
				// this.inviteForm.controls['token'].setValue(this.user.authToken);
				// this.inviteForm.controls['email'].setValue(this.user.email);
				this.inviteForm.controls['name'].setValue(this.user.firstName + " " + this.user.lastName);
				this.inviteForm.controls['password'].clearValidators();
				this.inviteForm.controls['password_confirmation'].clearValidators();
				this.inviteForm.controls['password'].updateValueAndValidity();
				this.inviteForm.controls['password_confirmation'].updateValueAndValidity();
				this.facebook = true;
			}
		});
	}
	get userInfo() { return this.inviteForm.controls; }
	
	facebookSignup(): void {
		this.authService.signIn(FacebookLoginProvider.PROVIDER_ID);
	}
	
	onSubmit(){
		if(this.inviteForm.invalid){
			return;
		}
		console.log(this.inviteForm.value);
		this.registerService.invitedUser(this.inviteForm.value).subscribe(
			(resp: any) => {
				if(resp.code_status == 200 && resp.data){
					console.log(resp);
				}
			},
			(err: any) => {
				// this.apiError = [];
				if(err.status == 422 && err.error.data.subdomain){
					console.log(err);
				}
			}
		);
	}
}
